import Swiper, { Lazy, Navigation, Pagination } from "swiper";
import SinglePost from "./single-post";
import helpers from "../utils/helpers";
import ScrollMagic from "scrollmagic";

const SingleUsedMachinery = {
  init() {
    SinglePost.init();

    this.events();
    this.titleSlider();
    this.relatedSlider();
    SingleUsedMachinery.stickBtn(".btn.hero-btn");
    if ($(window).width() >= 1600) {
      SingleUsedMachinery.stickBtn(".news-aside");
    }
  },

  events() {
    $(".contact-accordion__toggle").on("click", function () {
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });
  },

  titleSlider() {
    const arrowsWrapp = $(".hero-control-arrows");

    const thumbs = new Swiper(".thumbs-slider", {
      modules: [Lazy, Navigation, Pagination],
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });

    const slider = new Swiper(".gallery-slider", {
      modules: [Lazy, Navigation, Pagination],
      spaceBetween: 10,
      slidesPerView: 1,
      thumbs: {
        swiper: thumbs,
      },
      navigation: {
        prevEl: arrowsWrapp.find(".swiper-button-prev")[0],
        nextEl: arrowsWrapp.find(".swiper-button-next")[0],
      },
    });
  },

  relatedSlider() {
    const arrowsWrapp = $(".related-control-arrows");

    new Swiper(".related-swiper", {
      modules: [Lazy, Navigation, Pagination],
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        prevEl: arrowsWrapp.find(".swiper-button-prev")[0],
        nextEl: arrowsWrapp.find(".swiper-button-next")[0],
      },
    });
  },

  handleSubmit() {
    const formEl = $(".vacancy-form");

    formEl.addClass("loading");
    $(".error", this).removeClass("error");

    if (helpers.validate(formEl)) {
      setTimeout(() => {
        SingleUsedMachinery.recaptcha();
      }, 250);
    } else {
      formEl.removeClass("loading");
      const erInp = formEl.find(".error");
      erInp.toArray().forEach((input) => {
        $(input).parent().parent().addClass("row-w-error");
      });
    }
  },

  stickBtn(element) {
    let viewPortH = window.innerHeight;
    let scrollOffset = viewPortH / 2 - 80;

    const hasAdminBar = $("body").hasClass("admin-bar");
    if (hasAdminBar) {
      scrollOffset -= 32;
    }

    var controller = new ScrollMagic.Controller();
    var scene = new ScrollMagic.Scene({
      triggerElement: element,
      offset: scrollOffset,
    })
      .setPin(element)
      .setClassToggle(element, "stuck")
      .addTo(controller);
  },
};

export default SingleUsedMachinery;
